<div class="gallery-video" [ngStyle]="{'background-image': 'url(' + video.big + ')'}" [style.width.px]="width"  [style.height.px]="height">
  <video muted playsinline id="gallery-video-{{index}}"  preload="auto"  >
    <source [src]="video.url" type="video/mp4">
  </video>
</div>
<svg-icon *ngIf="isLoading" name="spinner" class="gallery-video__spinner"></svg-icon>
